import { useGetApprovalConfigurationQuery } from '../../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { APP_GOVERNANCE_APPROVAL_ACTION, APP_GOVERNANCE_APPROVAL_TYPE_ID } from '../constants';
//Checks if portal is enabled for Product Approvals
export function useGetProductApprovalConfiguration({
  skip = false
}) {
  const {
    data,
    loading,
    error,
    refetch
  } = useGetApprovalConfigurationQuery({
    variables: {
      approvalTypeId: APP_GOVERNANCE_APPROVAL_TYPE_ID,
      approvalAction: APP_GOVERNANCE_APPROVAL_ACTION
    },
    skip
  });
  const configurationEnabled = data === null || data === void 0 ? void 0 : data.approvalConfiguration.enabled;
  return {
    enabled: configurationEnabled === undefined ? false : configurationEnabled,
    loading,
    error,
    refetch
  };
}